import { CAN_NOT_START_WITH_WHITE_SPACE } from './../../../../shared/regular-expressions/regex';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractAddComponent } from '../../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { IMedication, IPatient, IMedicationRequest } from '@ahryman40k/ts-fhir-types/lib/R4';
import { ModalController } from '@ionic/angular';
import { AlertService } from '../../../../widgets/entry-components/alert/services/alert.service';

@Component({
  selector: 'inc-taked-medication-add',
  templateUrl: './taked-medication-add.component.html',
  styleUrls: ['./taked-medication-add.component.scss'],
})
export class TakedMedicationAddComponent extends AbstractAddComponent<IMedicationRequest> implements OnInit {
  @Input() patient: IPatient;
  @Input() user: any;
  @Input() extraData: IMedication[];

  @Input() dosagePeriods: { text: string, value: string }[];
  @Input() days: { text: string, value: string }[];
  @Input() doseUnit: { text: string, value: string };
  @Output() callMedicationSave: EventEmitter<IMedication> = new EventEmitter();
  @Output() callDelete: EventEmitter<string> = new EventEmitter();

  // addingMedication = false;
  // panelOpenState = false;

  constructor(private modalController: ModalController, private alertService: AlertService) {
    super();
  }

  ngOnInit() {
    if (this.inData) { // update
      this.form.controls.medicationRequest.patchValue(this.inData);
      /*this.form.controls.medicationGroupDisplayer
        .setValue(this.extraData.find((element: IMedication) => (this.inData.basedOn as IReference).reference === element.id).form.text); */
    } else { // add
      this.form.get('medicationRequest.subject').setValue({ reference: this.patient.id, display: this.patient.name[0].text });
      this.form.get('medicationRequest.requester').setValue({ display: this.user.displayName, reference: this.user.uid });
      this.form.get('medicationRequest.recorder').setValue({ display: this.user.displayName, reference: this.user.uid });
      this.form.get('medicationRequest.dosageInstruction.0.doseAndRate.0.doseQuantity.unit').setValue(this.doseUnit.value);
    }
  }

  resetForm() {
    return new FormGroup({
      medicationRequest: new FormGroup({
        id: new FormControl(''),
        authoredOn: new FormControl(new Date().toISOString()),
        basedOn: new FormArray([
          new FormGroup({
            reference: new FormControl(''),
            display: new FormControl('')
          })
        ]),
        medicationReference: new FormGroup({
          display: new FormControl('', Validators.compose([Validators.required, Validators.pattern(CAN_NOT_START_WITH_WHITE_SPACE)])),
        }),
        dosageInstruction: new FormArray([
          new FormGroup({
            timing: new FormGroup({
              repeat: new FormGroup({
                dayOfWeek: new FormControl(''),
                periodUnit: new FormControl('')
              })
            }),
            doseAndRate: new FormArray([
              new FormGroup({
                doseQuantity: new FormGroup({
                  value: new FormControl(''),
                  unit: new FormControl('')
                }),
                rateQuantity: new FormGroup({
                  value: new FormControl(''),
                  unit: new FormControl('')
                })
              })
            ])
          })
        ]),
        note: new FormArray([
          new FormGroup({
            text: new FormControl('')
          })
        ]),
        dispenseRequest: new FormGroup({
          validityPeriod: new FormGroup({
            start: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0, 0).toString())
          })
        }),
        subject: new FormGroup({
          reference: new FormControl(''),
          display: new FormControl('')
        }),
        requester: new FormGroup({
          reference: new FormControl(''),
          display: new FormControl('')
        }),
        recorder: new FormGroup({
          reference: new FormControl(''),
          display: new FormControl('')
        }),
        // medicationGroupDisplayer helyett
        category: new FormGroup({
          text: new FormControl('')
        })
      }),
      // medicationGroupDisplayer: new FormControl({ value: '', disabled: true })
    });
  }

  // csak a belsőknek kell, hogy req-ek legyenek a külsőknek nem
  resetMedicationForm(): FormGroup {
    return new FormGroup({
      status: new FormControl('active'),
      code: new FormGroup({
        text: new FormControl('', Validators.required)
      }),
      form: new FormGroup({
        text: new FormControl('', Validators.required)
      }),
      amount: new FormGroup({
        numerator: new FormGroup({
          value: new FormControl(''),
          unit: new FormControl('')
        })
      }),
      batch: new FormGroup({
        lotNumber: new FormControl('')
      })
    });
  }

  close() {
    this.modalController.dismiss();
  }

  submit(inData: IMedicationRequest) {
    this.modalController.dismiss(inData);
  }

  /* openMedicationAdd(): void {
    this.addingMedication = this.panelOpenState = true;
    this.form.get('medicationRequest.basedOn.reference').reset();
    this.form.get('medicationRequest.basedOn.reference').disable();
    this.form.get('medicationGroupDisplayer').reset();
    this.form.addControl('medication', this.resetMedicationForm());
  }

  cancelMedicationAdd() {
    this.closeMedicationAdd();
  }

  submitMedicationAdd(medication: IMedication) {
    this.callMedicationSave.emit(medication);
    this.closeMedicationAdd();
  }

  deleteMedication(medicationId: string) {
    this.callDelete.emit(medicationId);
    this.form.get('medicationRequest.basedOn.reference').reset();
  }

  openDeleteAlert(id: string) {
    this.alertService.presentDelete(this.extraData.find((med: IMedication) => med.id === id).code.text, 'medicine'.toUpperCase(), () => {
      this.deleteMedication(id);
    });
  }

  medicationChanged(event): void {
    const value = this.extraData.find((med: IMedication) => med.id === event.detail.value);
    if (value) {
      this.form.get('medicationGroupDisplayer').setValue(value.form.text);
    }
  }

  closeMedicationAdd(): void {
    this.panelOpenState = false;
    setTimeout(() => {
      this.addingMedication = false;
      this.form.removeControl('medication');
      this.form.get('medicationRequest.basedOn.reference').enable();
    }, 250);
  } */
}
